import React, { useEffect } from 'react'
import {  useNavigate } from 'react-router-dom';

export const Protected = (children) => {

  const Component = children.Component
  const navigate = useNavigate();
  useEffect(() => {
    let token = localStorage.getItem('user_token');
    if (!token) {
      navigate("/login")
    }
  }, [])
  return (
    <>
      <Component />
    </>
  )
}


